// Соединение берём общее, через initializeDB: сырой openDB(DB_NAME, DB_VERSION)
// заводил на каждый вызов отдельное соединение и никогда его не закрывал.
// Пока версия БД не менялась, это просто копило коннекты; при смене версии
// апгрейд вставал намертво, ожидая их закрытия, и приложение зависало.
import { initializeDB } from '../config/db';
import { SPOTTER_TRAINING_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const spotterTrainingService = {
    /**
     * Submit spotter training to server
     */
    async submit(training) {
        try {
            const response = await axiosInstance.post('/spotter-training/submit', training);
            return response.data;
        } catch (error) {
            console.error('Error submitting spotter training:', error);
            throw error;
        }
    },

    /**
     * Save spotter training as draft in IndexedDB
     */
    async saveDraft(training) {
        const db = await initializeDB();
        const now = new Date().toISOString();

        const trainingToSave = {
            ...training,
            updatedAt: now
        };

        // Only set status to draft if not already set
        if (!trainingToSave.status) {
            trainingToSave.status = 'draft';
        }

        if (!trainingToSave.createdAt) {
            trainingToSave.createdAt = now;
        }

        await db.put(SPOTTER_TRAINING_STORE, trainingToSave);
        return trainingToSave;
    },

    /**
     * Load spotter training by UUID from IndexedDB
     */
    async loadByUuid(uuid) {
        const db = await initializeDB();
        return await db.get(SPOTTER_TRAINING_STORE, uuid);
    },

    /**
     * Get all spotter trainings from IndexedDB
     */
    async getAll() {
        const db = await initializeDB();
        return await db.getAll(SPOTTER_TRAINING_STORE);
    },

    /**
     * Delete spotter training from IndexedDB
     */
    async delete(uuid) {
        const db = await initializeDB();
        await db.delete(SPOTTER_TRAINING_STORE, uuid);
    }
};

export default spotterTrainingService;
